import { withDependencies } from '@wix/thunderbolt-ioc'
import type { TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import { CurrentRouteInfoSymbol } from '@wix/thunderbolt-symbols'
import type { ICurrentRouteInfo } from 'feature-router'

export const GetCurrentPageIdHandler = withDependencies(
	[CurrentRouteInfoSymbol],
	(currentRouteInfo: ICurrentRouteInfo): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				getCurrentPageId(): string {
					return currentRouteInfo.getCurrentRouteInfo()!.pageId
				},
			}
		},
	})
)
